import {request} from "./request";

export function AddCampusActivities(title, location, lat, lng, des, maxp, maxSize, minSize, team, endTime) {
  return request({
    url: 'CampusActivities/AddCampusActivities',
    params: {
      title, location, lat, lng, des, maxp, maxSize, minSize, team, endUnixTime:endTime
    }
  })
}

export function GetCampusActivitiesList(team) {
  return request({
    url: 'CampusActivities/GetCampusActivitiesList',
    params: {
      team
    }
  })
}

export function GetCampusActivitiesInfoById(id) {
  return request({
    url: 'CampusActivities/GetCampusActivitiesInfoById',
    params: {
      id
    }
  })
}

export function DelCampusActivitiesById(id) {
  return request({
    url: 'CampusActivities/DelCampusActivitiesById',
    params: {
      id
    }
  })
}

export function GetCampusActivitiesStuById(cid, key, team, page) {
  return request({
    url: 'CampusActivities/GetCampusActivitiesStuById',
    params: {
      cid, key, team, page
    }
  })
}

export function GetCampusActivitiesTeamMates(code,cid) {
  return request({
    url: 'CampusActivities/GetCATeamMates',
    params: {
      code,cid
    }
  })
}

export function DelCampusActivitiesStuById(id) {
  return request({
    url: 'CampusActivities/DelCampusActivitiesStuById',
    params: {
      id
    }
  })
}
